const contributors = [
    {
        name: 'Silverfeelin',
        url: 'https://github.com/Silverfeelin'
    },
    {
        name: 'Nafiz Hasan',
        url: 'https://github.com/Nafiz1'
    },
    {
        name: 'Kathryn Kosey',
        url: 'https://github.com/kakosey'
    },
    {
        name: 'nodeMD',
        url: 'https://github.com/nodeMD'
    },
    {
        name: 'Meowtrix',
        url: 'https://github.com/Gelleode'
    }
];

export default contributors;